import PageComponent from 'components/Dashboard/PageComponent'
import { Link } from 'gatsby'
import { DashboardTitle } from './DashboardTitleContext'
import { MatchedResults } from './Results'

const PhotoEscalationQueue: PageComponent = () => {
  return (
    <div className="container">
      <DashboardTitle title="Photo Escalation Queue" />

      <MatchedResults
        queueName="EscalatedPhotoQueue"
        titleFn={(qty) => (
          <>
            <strong>{qty}</strong> <span className="has-text-danger">escalated</span> photo results to verify
            <br />
            <Link className="is-size-6 has-text-weight-normal" to="/dashboard/photo-verifications">
              Normal Photo Verification Queue
            </Link>
          </>
        )}
      />
    </div>
  )
}

PhotoEscalationQueue.displayName = 'Escalated Photos'
PhotoEscalationQueue.path = '/escalated-photo-verifications'
PhotoEscalationQueue.allowedGroups = ['dashboard', 'rapid_photo_verifiers']

export default PhotoEscalationQueue
